import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  x?: number;
}
export function Reveal({
  children,
  delay = 0,
  y = 28,
  x = 0
}: RevealProps) {
  return <MotionBox initial={{
    opacity: 0,
    y,
    x
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-140" data-mp="3gh8ogpq12i86">
      {children}
    </MotionBox>;
}